import {Pill} from '@wandb/weave/components/Tag';
import React, {useState} from 'react';

import * as Tooltip from '../UserActivityDashboard/components/Tooltip';

export const OrgRolesBetaTooltip = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip.Provider>
      <Tooltip.Root open={isOpen} onOpenChange={setIsOpen}>
        <Tooltip.Trigger>
          <Pill color="teal" label="Beta" />
        </Tooltip.Trigger>
        <Tooltip.Portal>
          <Tooltip.Content className="px-12 py-6">
            <p className="font-normal">
              This feature is in Beta. For further guidance, please reach out to
              support@wandb.com
            </p>
          </Tooltip.Content>
        </Tooltip.Portal>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
